// @flow

import _ from 'lodash';

import kv from 'rgs-knockout-validation';
import type { ValidationGroupInterface } from 'rgs-knockout-validation';
import type { Observable } from 'rgs-knockout';

export interface ValidatableInterface {
	constructor (): void;

	validationGroup (options?: Object): ValidationGroupInterface;

	validationArray (Object): Array<Observable<any>>;
}

export const ValidatableMixin = (superclass: any) => (
	class Validatable extends superclass implements ValidatableInterface {
		validationArray (options: Object): Array<Observable<any>> {
			console.warn('`validationArray` not implemented', this, options);
			return [];
		}

		_validationArrayDefaultOptions (): Object {
			return {};
		}

		//eslint-disable-next-line no-unused-vars
		_validationGroupDefaultOptions (currentGroupOptions?: Object = {}): Object {
			return {};
		}

		// eslint-disable-next-line max-len
		validationGroup (arrayOptions?: Object = {}, groupOptions?: Object = {}): ValidationGroupInterface {
			arrayOptions = _.defaults(
				{},
				arrayOptions || {},
				this._validationArrayDefaultOptions()
			);
			groupOptions = _.defaults(
				{},
				groupOptions || {},
				this._validationGroupDefaultOptions(groupOptions));

			if (this._validationGroup) {
				this._validationGroup.dispose();
			}
			this._validationGroup = kv.group(this.validationArray(arrayOptions), groupOptions);

			return this._validationGroup;
		}
	}
);

export const Validatable = ValidatableMixin(class {});
